import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip';

import { type ILogType } from '../model';

const typeToContent: Record<ILogType, string> = {
  Company: 'Organization',
  continuity: 'Continuity Escrow',
  CustodianProfile: 'Software Custodian',
  saas: 'SaaS Escrow',
  software: 'Software Escrow',
  Backup: 'Software Backups',
  App: 'Application',
};

type Props = {
  type: ILogType;
};

const TypeTooltip = ({ type, children }: React.PropsWithChildren<Props>) => {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent
          side="right"
          align="center"
          className="max-w-[281px] bg-white text-sm text-popover-foreground shadow-md border-border"
        >
          {typeToContent[type]}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default TypeTooltip;
